import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import NuroFit from "./components/NuroFit/NuroFit";
import PrivacyPolicy from "./components/NuroFit/PrivacyPolicy";
import TermsConditions from "./components/NuroFit/TermsConditions";
import AdsTxtContent from "./components/AdsTxtContent";
import PasswordReset from "./components/NuroFit/PasswordReset";
import AccountDeletion from "./components/NuroFit/AccountDeletion";
import EmailConfirmation from "./components/NuroFit/EmailConfirmation";
import ResetSuccess from "./components/NuroFit/ResetSuccess";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} /> 
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/nurofit" element={<NuroFit />} />
          <Route path="/nurofit/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/nurofit/terms" element={<TermsConditions />} />
          <Route path="/app-ads.txt" element={<AdsTxtContent />} />
          <Route path="/nurofit/reset-password" element={<PasswordReset />} />
          <Route path="/nurofit/reset-success" element={<ResetSuccess />} />
          <Route path="/nurofit/delete-account" element={<AccountDeletion />} />
          <Route path="/nurofit/confirm-email" element={<EmailConfirmation />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;